import React, { Component } from 'react'
import Axios from 'axios'
import { getUser } from '../../actions/session'
import CustomLoader from '../common/loader'
import CarrierEdit from './carrierEdit'
import CustomModal from '../common/modal'
import { Notifications } from '../common/notification'
import Switch from "react-switch";
import { CARRIER_DASHBOARD_API, CARRIER_LISTING, CARRIER_TOGGAL,LOGIN_URL,SPECIFIC_CARRIER_LISTING } from '../../config/rest_endpoints'
import { RC_LOAD_LOGIN, CARRIER_INFO } from '../routers/RouteConstants'
import { withRouter, Link, Redirect } from 'react-router-dom'
import CarrierAdd from './carrierAdd'
import componentTabs from './componentTabs'
import Pagination from "react-js-pagination";


class CarrierInformation extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User: getUser(),
            carrierTable: [],
            isGetting: false,
            isEditModal: false,
            editData: [],
            updateMsg: '',
            isAddModal:false,
            //pagination state
            activePage: 1,
            itemsCount: 9,
            totalCount: null,
            name:'',
            tableData:[],
            isLoginURL: false
        }
        this.openEditModal = this.openEditModal.bind(this)
        this.closeAddModal = this.closeAddModal.bind(this)
        this.openAddModal = this.openAddModal.bind(this)
        this.closeEditModal = this.closeEditModal.bind(this)
        this.getCarrierData = this.getCarrierData.bind(this)
        this.toggleSwitch = this.toggleSwitch.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
    }

    openEditModal(row) {
        this.setState({
            isEditModal: true,
            editData: row
        })
    }

    closeEditModal() {
        this.setState({
            isEditModal: false,
        })
    }

    openAddModal() {
        this.setState({
           isAddModal:true
        })
    }

    closeAddModal() {
        this.setState({
            isAddModal:false
         })
    }

    componentDidMount() {
        this.getCarrierData()
        // this.getTable()
        // this.renderCarrierTable()

    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, () => {
            this.getCarrierData()
        });
    }

    getCarrierData() {
        const { User, activePage, itemsCount } = this.state
        this.setState({
            isGetting: true
        })
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.get(`${SPECIFIC_CARRIER_LISTING}/${this.props.userId}/details`, { headers }).then(res => {
            if (res) {
                console.log('res :>> ', res);
                var resp = res.data.data
                // console.log('object :>> ', resp);
                // let carrierTable = Object.keys(resp).map(i => {
                //     return resp[i]
                // })
                this.setState({
                    carrierTable:resp,
                    isGetting: false,
                    // totalCount:res.data.pageinfo.totalCount
                })
            } else {

            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({ isLoginURL: true })
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false,
            })
        })
    }

    toggleSwitch(row) {
        const { User } = this.state
        const data = {
            "carrierid": row.carrierid,
            "concurrentcalls": row.concurrentcalls,
            "cps": row.cps,
            "status": !row.status
        }
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.put(`${CARRIER_TOGGAL}/5e95f6520d5cf5616da77968/${row.name}/changeCarrierStatus`, data, { headers }).then(res => {
            if (res) {
                this.setState({
                    updateMsg: res.data.message
                })
                this.getCarrierData()
                Notifications.notify(this.state.updateMsg, "Success", "success");
            }
            else {
                Notifications.notify("error failed", "Failed", "error");
            }
        })

    }

    onRedirecting(data) {
        var id = data.id
        var Name = data.carrierName
        console.log('Name :>> ', Name);
        this.setState({name:Name})
        this.props.history.push(`${CARRIER_INFO}/${id}/${Name}`)
    }


    renderCarrierTable() {
        const { carrierTable } = this.state
        if(carrierTable === null || carrierTable === undefined || carrierTable.length === 0) {
            return (
                <div className="ml-4 mt-2">
                    <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                    <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                </div>
            )
        }
        else {
            return carrierTable.map((row, idx) => {
                return (
                    <tr key={idx}>
                        <td style={{textAlign:'center'}} >{row['name']}</td>
                        {/* <td>{row.carrierID}</td> */}
                        <td style={{textAlign:'center'}}>{row['cps']}</td>
                        <td style={{textAlign:'center'}}>{row.sessions}</td>
                        <td style={{textAlign:'center'}}>{row['prefix'] == '' ? 'N/A' : row['prefix']}</td>
                         <td style={{textAlign:'center'}}>{row.holdTime == ''? 'N/A' : row.holdTime }</td>
                        <td style={{textAlign:'center'}}>{row.status === false ? <span className="badge badge-danger">Suspend</span> : <span className="badge badge-success">Active</span>}</td>
                        {/* <td><span className="size-1"><Switch height={20} width={50} onChange={this.toggleSwitch.bind(this, row)} checked={row.status} /></span></td> */}
                        <td className='edit-button'><i className=" fa fa-edit mr-2" onClick={this.openEditModal.bind(this, row)}></i></td>
                    </tr>
                )
            })
        }
    }

    render() {
        const { isGetting, isEditModal, editData,isAddModal, itemsCount, totalCount } = this.state
        console.log('123',totalCount)
        let editCarrierModal = {
            details: {
                info: `Edit ${editData.name}`,
                msg: <CarrierEdit close={this.closeEditModal} previousData={editData} carrierListing={this.getCarrierData} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeEditModal },
            cancelBtn: { label: "Cancel", action: this.closeEditModal }
        }
        let addCarrierModal = {
            details: {
                info: `Add Carrier`,
                msg: <CarrierAdd close={this.closeAddModal}  carrierListing={this.getCarrierData} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeAddModal },
            cancelBtn: { label: "Cancel", action: this.closeAddModal }
        }
        if (this.state.isLoginURL === true) {
            return <Redirect to={LOGIN_URL} ></Redirect>
        }
        return (
            <div>
                <CustomModal
                    visibility={isEditModal}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    details={editCarrierModal.details}
                    showBtns={false}
                    cancelBtn={editCarrierModal.cancelBtn}
                    crossBtn={editCarrierModal.crossBtn}
                />
                 <CustomModal
                    visibility={isAddModal}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    details={addCarrierModal.details}
                    showBtns={false}
                    cancelBtn={addCarrierModal.cancelBtn}
                    crossBtn={addCarrierModal.crossBtn}
                />
                <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body border-left-dark-alpha border-right-dark-alpha ">
                    {/* <div className="card-header header-elements-inline">
                        <h3 className="card-title ">Carriers Table</h3>
                        <div className="header-elements">
                            <button type="submit" className="btn bg-blue ml-3" onClick={this.openAddModal}>Add Carrier <i className="fas fa-plus ml-2"></i></button>
                        </div>
                    </div> */}
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                        <div className="datatable-header border-0">
                            <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                {/* <label><span>Filter:</span>
                            <input type="search" className="" placeholder="Type to filter..." value={this.state.searchValue} onChange={this.searchSpace} aria-controls="DataTables_Table_0" />
                        </label> */}
                                <div class="input-group">
                                    <input type="text" class="form-control border-right-0"  placeholder="Filter Carrier" />

                                    <span class="input-group-append">
                                        <button class="btn search-button" type="button"><i class="fa fa-search"></i></button>
                                    </span>
                                </div>
                            </div>
                            <div className="header-elements">
                            {/* <button type="submit" className="btn bg-blue ml-3 float-right" onClick={this.openAddModal}>Add Carrier <i className="fas fa-plus ml-2"></i></button> */}
                            </div>
                        </div>
                        
                        <div className="datatable-scroll " style={{ overflowX: 'auto' }}>
                            <table style={{border:'1px solid #ddd',borderCollapse:'collapse'}} className="table table-striped  no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                <thead>
                               
                                    <tr className="stickeyHeader">
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Name</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>CPS</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Sessions</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Prefix</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Hold TIme</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Status</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isGetting ? <CustomLoader /> : this.renderCarrierTable()}

                                </tbody>
                            </table>
                        </div>
                        <div className="datatable-footer mt-1">
                           {totalCount >= 9 ?  
                           <div className="mt-3">
                                <Pagination
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={itemsCount}
                                    totalItemsCount={totalCount}
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange.bind(this)}
                                />
                            </div> :''}

                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(CarrierInformation)